export default value => (value ? 'block' : 'none');
